export { default as createOneDialogMutation } from './create-one-dialog-mutation';
export { default as dialogFragment } from './dialog-fragment';
export { default as removeByIdDialogMutation } from './remove-by-id-dialog-mutation';
